<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/config/craft/template/page"
			getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('zhanshifangshi')">
						<yi_dictionary_select :type="'EQUIPMENT_CRAFT_TEMPLATE_TYPE'" :ids.sync="yt.conditions.type">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('shujumoban')">
						<yi_cross_select :max="1" :component="'admin_data_template_protocol_list'"
							:ids.sync="yt.conditions.templateId">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('shebeiSN')">
						<yi_cross_select :selectTitle="'sn'" :component="'web_base_equipment_list'"
							:ids.sync="yt.conditions.equipmentId">
						</yi_cross_select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1,null,afterGet)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({orderBy:'createTime desc'})">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1',beforeShowEditDialog)"
					type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text"
							@click="yt.showEditDialog('bianji', scope.row,'w1',beforeShowEditDialog)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/config/craft/template/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
			<template #zhanshineirong="scope">
				<span>{{ base64.decode(scope.row.showJson)}}</span>
			</template>
			<!-- 底部插槽 -->
			<!-- <div slot="footer"></div> -->
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="'80%'" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<div :class="(yt.editObj.type == 1 || yt.editObj.type == 2)?'dialog-scroller' : ''">
					<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
						<el-form-item :label="$t('zhanshifangshi')" required>
							<el-select v-model="yt.editObj.type">
								<el-option :label="$t('anshujumoban')" :value="1"></el-option>
								<el-option :label="$t('anshebei')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-if="yt.editObj.type == 1" :label="$t('shujumoban')" required>
							<yi_cross_select :max="1" :component="'admin_data_template_protocol_list'"
								:ids.sync="yt.editObj.templateId">
							</yi_cross_select>
						</el-form-item>
						<el-form-item v-if="yt.editObj.type == 2" :label="$t('shebeiSN')" required="required">
							<yi_cross_select :selectTitle="'sn'" :component="'web_base_equipment_list'" :max="1"
								:ids.sync="yt.editObj.equipmentId">
							</yi_cross_select>
						</el-form-item>
						<el-form-item v-if="yt.editObj.type == 1 || yt.editObj.type == 2" :label="$t('zhanshineirong')" required class="full-width-item">
							<el-input :placeholder="$t('qingshuruJSONwenben')" v-model="yt.editObj.showJsonTmp"
								type="textarea" maxlength="50000" show-word-limit
								:autosize="{ minRows: 12, maxRows: 12}">
							</el-input>
							<el-button size="mini" type="primary" @click="previewShowJson" style="margin-top: 10px;">
								{{$t('yulan')}}
							</el-button>
						</el-form-item>
						<el-form-item v-if="yt.editObj.type == 1 || yt.editObj.type == 2" :label="$t('fenleizhanshineirong')" required class="full-width-item">
							<el-input :placeholder="$t('qingshuruJSONwenben')" v-model="yt.editObj.classifiedJson"
								type="textarea" maxlength="50000" show-word-limit
								:autosize="{ minRows: 12, maxRows: 12}">
							</el-input>
							<el-button size="mini" type="primary" @click="previewClassifiedJson" style="margin-top: 10px;">
								{{$t('yulan')}}
							</el-button>
						</el-form-item>

					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/config/craft/template/create', beforeAdd)"
						type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<div class="dialog-scroller">
					<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
						<el-form-item :label="$t('zhanshifangshi')" required>
							<el-select disabled v-model="yt.editObj.type">
								<el-option :label="$t('anshujumoban')" :value="1"></el-option>
								<el-option :label="$t('anshebei')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-if="yt.editObj.type == 1" :label="$t('shujumoban')" required>
							<yi_cross_select :max="1" :component="'admin_data_template_protocol_list'"
								:ids.sync="yt.editObj.templateId">
							</yi_cross_select>
						</el-form-item>
						<el-form-item v-if="yt.editObj.type == 2" :label="$t('shebeiSN')" required="required">
							<yi_cross_select disabled :selectTitle="'sn'" :component="'web_base_equipment_list'"
								:max="1" :ids.sync="yt.editObj.equipmentId">
							</yi_cross_select>
						</el-form-item>
						<el-form-item v-if="yt.editObj.type == 1 || yt.editObj.type == 2" :label="$t('zhanshineirong')" required class="full-width-item">
							<el-input v-model="yt.editObj.showJsonTmp" type="textarea" maxlength="50000"
								show-word-limit :autosize="{ minRows: 12, maxRows: 12}">
							</el-input>
							<el-button size="mini" type="primary" @click="previewShowJson" style="margin-top: 10px;">
								{{$t('yulan')}}
							</el-button>
						</el-form-item>
						<el-form-item v-if="yt.editObj.type == 1 || yt.editObj.type == 2" :label="$t('fenleizhanshineirong')" required class="full-width-item">
							<el-input v-model="yt.editObj.classifiedJson" type="textarea" maxlength="50000"
								show-word-limit :autosize="{ minRows: 12, maxRows: 12}">
							</el-input>
							<el-button size="mini" type="primary" @click="previewClassifiedJson" style="margin-top: 10px;">
								{{$t('yulan')}}
							</el-button>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/config/craft/template/update',beforeAdd)"
						type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 预览弹框 -->
		<el-dialog :title="$t('yulan')" :visible.sync="previewDialogVisible" width="90%" top="5vh" append-to-body custom-class="preview-dialog">
			<el-tabs v-model="previewActiveTab" class="preview-tabs">
				<!-- 动态tab页面 - 只显示JSON的key作为tab标签 -->
				<el-tab-pane v-for="(value, key) in previewTabs" :key="key" :label="key" :name="key">
					<div class="preview-html" v-html="value"></div>
				</el-tab-pane>
			</el-tabs>
			<span slot="footer" class="dialog-footer">
				<el-button @click="previewDialogVisible = false">{{$t('quxiao')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	const Base64 = require('js-base64').Base64
	export default {
		name: 'admin_data_template_technology_list',
		data() {
			return {
				base64: Base64,
				columns: [{
						label: 'zhanshifangshi',
						type: 'dictionary',
						key: 'EQUIPMENT_CRAFT_TEMPLATE_TYPE',
						prop: 'type',
						width: 130
					}, {
						label: 'shujumoban',
						prop: 'template.name',
						width: 130
					},
					{
						label: 'shebeiSN',
						prop: 'equipment.sn'
					}, {
						label: 'zhanshineirong',
						// prop: 'showJson',
						type: 'slot',
					},
					{
						label: 'fenleizhanshineirong',
						prop: 'classifiedJson',

					}, {
						label: 'caozuo',
						type: 'slot',
						width: 130,
						fixed: 'right'
					}
				],
				// 预览相关
				previewDialogVisible: false,
				previewActiveTab: '',
				previewTabs: {},
				previewCode: ''
			};
		},
		watch: {
			'yt.editObj.action'(value) {
				if (value === 'bianji') {
					this.$nextTick(() => {
						this.$set(this.yt.editObj, 'showJsonTmp', this.base64.decode(this.yt.editObj.showJsonTmp))
					});

				}
			}

		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					orderBy: 'createTime desc',
				}
				this.yt.get(1);
			}, 300)

		},

		methods: {
			beforeShowEditDialog(params) {
				params.showJsonTmp = params.showJson
				return params
			},

			beforeAdd(params) {
				params.showJson = this.base64.encode(params.showJsonTmp)
				return params
			},

			// 预览展示内容
			previewShowJson() {
				this.previewJson(this.yt.editObj.showJsonTmp)
			},

			// 预览分类展示内容 - dict为tab页，data的list为table单列显示
			previewClassifiedJson() {
				try {
					// 去除首尾空格，并清理所有控制字符
					let cleanedJson = this.yt.editObj.classifiedJson.replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '')
					if (!cleanedJson) {
						this.$message.error(this.$t('jsonwenbenweikong'))
						return
					}
					
					// 清理所有控制字符
					cleanedJson = cleanedJson.replace(/[\x00-\x1F\x7F-\x9F]/g, '')
					
					const data = JSON.parse(cleanedJson)
					this.previewCode = JSON.stringify(data, null, 2)
					
					// 处理分类展示内容：数组格式，每个元素包含dict和data
					if (Array.isArray(data)) {
						const processedTabs = {}
						data.forEach((item, index) => {
							const tabKey = item.dict || `Tab${index + 1}`
							const listData = item.data || []
							
							// 生成单列表格HTML，第一行是表头"点位编码"，后面是code数据
							let tableHtml = '<table border="1" cellspacing="0" cellpadding="4" style="width:100%;border-collapse:collapse;">'
							
							// 第一行：固定表头"点位编码"
							tableHtml += '<tr style="background:#7f7f7f;color:#fff;">'
							tableHtml += '<th>点位编码</th>'
							tableHtml += '</tr>'
							
							// 从第二行开始：显示实际的code数据
							listData.forEach(row => {
								tableHtml += '<tr>'
								tableHtml += `<td>${row.code || ''}</td>`
								tableHtml += '</tr>'
							})
							
							tableHtml += '</table>'
							
							processedTabs[tabKey] = tableHtml
						})
						this.previewTabs = processedTabs
						// 设置第一个tab为active
						const firstTab = Object.keys(processedTabs)[0]
						if (firstTab) {
							this.previewActiveTab = firstTab
						}
					} else {
						// 如果不是数组，使用通用预览
						this.previewJson(this.yt.editObj.classifiedJson)
						return
					}
					this.previewDialogVisible = true
				} catch (error) {
					console.error('JSON解析错误:', error)
					this.$message.error(this.$t('jsoncuowu') + ': ' + error.message)
					this.previewTabs = {}
					this.previewActiveTab = ''
					this.previewCode = this.yt.editObj.classifiedJson
					this.previewDialogVisible = true
				}
			},

			// 预览JSON数据
			previewJson(jsonStr) {
				try {
					// 去除首尾空格，并清理所有控制字符
					let cleanedJson = jsonStr.replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '')
					if (!cleanedJson) {
						this.$message.error(this.$t('jsonwenbenweikong'))
						return
					}
					
					// 清理所有控制字符（包括换行、回车、制表符等）
					// JSON字符串中不能包含实际的控制字符，必须是转义形式
					cleanedJson = cleanedJson.replace(/[\x00-\x1F\x7F-\x9F]/g, '')
					
					const data = JSON.parse(cleanedJson)
					this.previewCode = JSON.stringify(data, null, 2)
					
					// 处理tab页面数据
					if (typeof data === 'object' && data !== null) {
						const processedTabs = {}
						// 遍历每个tab，解析html内容
						for (const [key, htmlValue] of Object.entries(data)) {
							if (typeof htmlValue === 'string') {
								// 将{和}转义，防止被Vue解析
								let processedHtml = htmlValue
									.replace(/\{/g, '&#123;')
									.replace(/\}/g, '&#125;')
								
								processedTabs[key] = processedHtml
							} else {
								processedTabs[key] = htmlValue
							}
						}
						this.previewTabs = processedTabs
						// 设置第一个tab为active
						const firstTab = Object.keys(processedTabs)[0]
						if (firstTab) {
							this.previewActiveTab = firstTab
						}
					} else {
						this.previewTabs = {}
						this.previewActiveTab = ''
					}
					this.previewDialogVisible = true
				} catch (error) {
					console.error('JSON解析错误:', error)
					this.$message.error(this.$t('jsoncuowu') + ': ' + error.message)
					this.previewTabs = {}
					this.previewActiveTab = ''
					this.previewCode = jsonStr
					this.previewDialogVisible = true
				}
			}
		}
	};
</script>

<style scoped="scoped" lang="scss">
	.content-box {
		padding: 10px 0;
	}

	/* 全宽表单项 - 文本框与标签在同一行，按钮在文本框后面 */
	.full-width-item {
		display: flex;
		align-items: flex-start;
		width: 98%;
		
		::v-deep .el-form-item__label {
			flex-shrink: 0;
		}
		
		::v-deep .el-form-item__content {
			flex: 1;
			width: auto;
			display: flex;
			align-items: flex-start;
			gap: 10px;
		}
		
		::v-deep .el-textarea {
			flex: 1;
		}
		
		::v-deep textarea {
			width: 100%;
		}
		
		::v-deep .el-button {
			margin-top: 0 !important;
			flex-shrink: 0;
		}
	}

	/* 预览弹框样式 */
	::v-deep .preview-dialog {
		.el-dialog__body {
			max-height: 70vh;
			overflow-y: auto;
		}
	}

	.preview-tabs {
		min-height: 50vh;
	}

	.preview-html {
		margin-top: 10px;
		font-size: 12px;
		text-align: center;
	}

	.preview-html /deep/ table {
		border-collapse: collapse;
		border-color: rgb(232, 232, 232);
		width: 100%;
	}

	.preview-html /deep/ table tbody tr:first-child {
		height: 26px;
		font-size: 12px;
		background: rgb(123, 127, 128);
		color: white;
	}

	.preview-html /deep/ table tbody tr:not(:first-child) {
		height: 26px;
		font-size: 12px;
		color: #606672;
	}

	.preview-html /deep/ table td,
	.preview-html /deep/ table th {
		border: 1px solid #e4e7ed;
		padding: 0 8px;
	}
</style>
